import { useMemo } from 'react';

import { SlashCommandExtension } from '@eluve/eluve-editor';
import { useAnalytics } from '@eluve/posthog-react';

import { useSnippets } from './useSnippets';

export const useSnippetEditorExtension = () => {
  const { snippets, addSnippet, tenantId, userId } = useSnippets();
  const analytics = useAnalytics('snippets');
  const sortedSnippets = useMemo(
    () => [...snippets].sort((a, b) => a.title.localeCompare(b.title)),
    [snippets],
  );

  const extension = SlashCommandExtension.configure({
    snippetOptions: {
      enabled: true,
      snippets: sortedSnippets,
      addSnippet,
      onItemSelect: (data: { id: string; title: string; content: string }) => {
        if (data) {
          analytics.capture('user_used_snippet', {
            tenantId,
            userId,
            snippetId: data.id,
            title: data.title,
            content: data.content,
          });
        }
      },
    },
  });

  return { snippetExtension: extension, snippetCount: snippets.length };
};
